module.exports = __webpack_public_path__ + "static/media/gmail-icon.d872d97e.svg";